import TopBar from "../../components/topBar/topBar";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiClient } from "../../api/apiClient";
import TrashIcon from './trash.svg';


export function ViewBooks() {
    const [books, setBooks] = useState([]);

    useEffect(() => {
        const getBooks = async () => {
            const req = await apiClient.get("/book");
            if (req.status == 200) {
                setBooks(req.data.data);
            } else {
                console.log(req);
            }
        }
        getBooks();
    }, []);

    async function handleDelete(id) {
        const req = await apiClient.delete(`/book/${id}`);
        console.log(req);
    }

    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-5xl px-4 sm:px-6 py-10">

                <Link
                    to="/dashboard"
                    className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
                >
                    <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Go Back
                </Link>

                <h1 className="mb-8 text-2xl font-light text-mainDark">View, edit or delete books</h1>

                <div className="rounded-2xl border border-mainDark/30 bg-mainWhite shadow-result overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b border-mainDark/20 bg-mainDark/3">
                                <th className="py-3 px-6 text-left text-xs uppercase tracking-widest font-medium text-mainDark/50">Book Name</th>
                                <th className="py-3 px-6 text-left text-xs uppercase tracking-widest font-medium text-mainDark/50 w-24">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {books.map((book, i) => (
                                <tr key={book._id} className={`border-b border-mainDark/10 transition-colors duration-150 hover:bg-mainBlue/5 ${i === books.length - 1 ? "border-b-0" : ""}`}>
                                    <td className="py-3 px-6">
                                        <Link to={`/edit-book/${book._id}`} className="text-mainDark text-sm hover:text-mainBlue transition-colors duration-150 underline underline-offset-2">
                                            {book.title ? book.title : book.trust}
                                        </Link>
                                    </td>
                                    <td className="py-3 px-6">
                                        <button
                                            type="button"
                                            onClick={() => handleDelete(book._id)}
                                            className="group rounded-lg p-1.5 text-mainDark/30 transition-all duration-150 hover:bg-red-50 hover:text-red-500"
                                            title="Delete"
                                        >
                                            <img src={TrashIcon} alt="Delete" className="h-4 w-4 opacity-50 group-hover:opacity-100" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
}

export default ViewBooks;
